import React from 'react';

function About({ content }) {
    const { paragraphs } = content;

    const bwStyle = {
        maxWidth: '100%',
        height: 'auto',
        marginBottom: '16px',
        border: '2px solid #000000',
        boxShadow: '2px 2px 0px #808080',
        filter: 'grayscale(100%) contrast(160%) brightness(95%)',
        imageRendering: 'pixelated',
        display: 'block'
    };

    return (
        <div style={{ padding: '4px' }}>
            <img 
                alt="Batuhan Yeşilyurt" 
                src={require('../../assets/erkmenesen1.jpg')} 
                style={bwStyle}
            />
            <h2>About</h2>
            {
                paragraphs.map((p, i) => (
                    <p key={i} style={{ marginBottom: '12px', lineHeight: '1.5' }}>{p}</p>
                ))
            }
        </div>
    );
}

export default About;
